import "reflect-metadata"
import { injectable } from 'inversify-props'
import { MarketplaceServiceAdapter } from "@/usecases/marketplace/adapter/MarketplaceServiceAdapter"
import { 
	findAll,
	findConfiguracoesPorLoja,
	updateConfiguracao,
	validarTokenParaLogin,
	validarRefreshToken,
	findAllAtributos,
	findAllCategoriasGlobais,
	findAllCanaisDeVenda,
	getProduto,
	updateProduto,
	createProduto,
	integrarProdutos,
	atualizarSincronizacaoProduto,
	validaProdutoExistente,
	findAllPedidos,
	integrarPedidos,
	findPedidoByVendaId,
	importarArquivoConfiguracao,
} from "@/api/marketplace"
import { AxiosRequestConfig } from "axios"
import { ConfiguracoesMarketplace, ImportacaoArquivoConfiguracao, ProdutoMarketplace } from "@/models"

@injectable()
export class MarketplaceService implements MarketplaceServiceAdapter {
	findAll = async (lojaId: string, params: any, config?: AxiosRequestConfig) => await findAll(lojaId, params, config)
	findConfiguracoesPorLoja = async (lojaId: string) => await findConfiguracoesPorLoja(lojaId)
	updateConfiguracao = async (configuracao: ConfiguracoesMarketplace) =>  await updateConfiguracao(configuracao)
	importarArquivoConfiguracao = async (importacaoArquivoConfiguracao: ImportacaoArquivoConfiguracao) => await importarArquivoConfiguracao(importacaoArquivoConfiguracao)
	validarTokenParaLogin = async (configuracao: ConfiguracoesMarketplace) =>  await validarTokenParaLogin(configuracao)
	validarRefreshToken = async (configuracaoId: string, refreshToken: string) =>  await validarRefreshToken(configuracaoId, refreshToken)
	findAllAtributos = async (params: any, config?: AxiosRequestConfig) => await findAllAtributos(params, config)
	findAllCategoriasGlobais = async (params: any, config?: AxiosRequestConfig) => await findAllCategoriasGlobais(params, config)
	findAllCanaisDeVenda = async (params: any, config?: AxiosRequestConfig) => await findAllCanaisDeVenda(params, config)
	getProduto = async (produtoId: string) => await getProduto(produtoId)
	updateProduto = async (produto: ProdutoMarketplace) => await updateProduto(produto)
	createProduto = async (produto: ProdutoMarketplace) => await createProduto(produto)
	integrarProdutos = async (lojaId: string) => await integrarProdutos(lojaId)
	atualizarSincronizacaoProduto = async (produtoId: string, sincronizar: boolean) => await atualizarSincronizacaoProduto(produtoId, sincronizar)
	validaProdutoExistente = async (produtoId: string, lojaId: string) => await validaProdutoExistente(produtoId, lojaId)
	findAllPedidos = async (lojaId: string, params: any, config?: AxiosRequestConfig) => await findAllPedidos(lojaId, params, config)
	integrarPedidos = async (lojaId: string) => await integrarPedidos(lojaId)
	findPedidoByVendaId = async (vendaId: string) => await findPedidoByVendaId(vendaId)
}